import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import BottomNav from "../components/BottomNav";
import InternalHeader from "../components/InternalHeader";
import { useAppState } from "../context/AppState";
import { authenticatedApi } from "../lib/api";
import { useLocale } from "../context/Locale";

const statusNames = {
  1: "Enviado al negocio",
  2: "Aceptado",
  3: "Motorizado asignado",
  4: "En camino",
  5: "Entregado",
  6: "Cancelado",
  7: "Listo para recoger",
  8: "Pago pendiente",
  10: "Programado",
};

export default function OrdersPage() {
  const { user } = useAppState();
  const { t } = useLocale();
  const [params] = useSearchParams();
  const [orders, setOrders] = useState([]);
  const [serviceOrders, setServiceOrders] = useState([]);
  const [loading, setLoading] = useState(Boolean(user));
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user?.auth_token) return;
    Promise.all([
      authenticatedApi("/get-orders", user.auth_token, { method: "POST", body: "{}" }),
      authenticatedApi("/service-hub/my-orders", user.auth_token),
    ])
      .then(([response, services]) => {
        setOrders(response?.data || []);
        setServiceOrders(services?.orders || []);
      })
      .catch((requestError) => setError(requestError.message))
      .finally(() => setLoading(false));
  }, [user]);

  return (
    <main className="food-app">
      <InternalHeader title={t("myOrders")} backTo="/account" />
      <div className="orders-page">
        {params.get("placed") && (
          <div className="order-success">
            <span>✓</span>
            <div><b>Pedido registrado</b><small>{params.get("placed")}</small></div>
          </div>
        )}

        {!user && (
          <section className="empty-cart">
            <span>🔐</span>
            <h2>{t("loginOrders")}</h2>
            <Link to="/account?next=/orders">Ir a mi cuenta</Link>
          </section>
        )}
        {loading && <div className="food-message"><b>Cargando pedidos…</b></div>}
        {error && <div className="food-message food-message--error"><b>{error}</b></div>}
        {!loading && user && !error && !orders.length && !serviceOrders.length && (
          <section className="empty-cart">
            <span>🧾</span>
            <h2>{t("noOrders")}</h2>
            <Link to="/food">Realizar mi primer pedido</Link>
          </section>
        )}
        <section className="order-list">
          {orders.map((order) => (
            <article className="published-order-card" key={order.id}>
              <header>
                <div>
                  {order.is_ratable && <Link to={`/rate-order/${order.id}`}>Calificar pedido</Link>}
                  <b>{statusNames[order.orderstatus_id] || "En proceso"}</b>
                </div>
                <time>{order.created_at}</time>
              </header>
              <h2>{order.unique_order_id}</h2>
              <Link className="published-order-card__store" to={`/food/stores/${order.restaurant?.slug || ""}`}>
                {order.restaurant?.name || "Pedido Delivery Huaraz"}
              </Link>
              <div className="published-order-card__items">
                {(order.orderitems || []).map((item) => (
                  <div key={item.id}>
                    <span>×{item.quantity} &nbsp; {item.name}</span>
                    <b>S/ {Number(item.price || 0).toFixed(2)}</b>
                  </div>
                ))}
              </div>
              <div className="published-order-card__totals">
                <div>
                  <span>Modalidad:</span>
                  <b>{Number(order.delivery_type) === 2 ? "Recojo en el negocio" : "Delivery"}</b>
                </div>
                <div>
                  <span>{Number(order.delivery_type) === 2 ? "Tarifa de recojo:" : "Tarifa de entrega:"}</span>
                  <b>{Number(order.delivery_type) === 2 ? "Sin costo" : `S/ ${Number(order.delivery_charge || 0).toFixed(2)}`}</b>
                </div>
                <div><span>Total</span><b>S/ {Number(order.total || 0).toFixed(2)}</b></div>
                <div><span>Forma de pago:</span><b>{order.payment_display || order.payment_mode || "No especificado"}</b></div>
              </div>
              <p>{Number(order.delivery_type) === 2 ? "El negocio avisará cuando esté listo para recoger." : (order.delivery_address || "")}</p>
              <Link className="published-order-card__open" to={`/orders/${encodeURIComponent(order.unique_order_id)}`}>
                Ver seguimiento
              </Link>
            </article>
          ))}
          {serviceOrders.map((order) => (
            <Link className="order-card order-card--service" key={`service-${order.id}`} to={`/service-orders/${encodeURIComponent(order.reference)}`}>
              <div>
                <small>{order.service_type === "TAXI" ? "TAXI" : "ENVÍO"} · {order.reference}</small>
                <h2>{order.pickup_address} → {order.dropoff_address}</h2>
              </div>
              <b>S/ {Number(order.total || 0).toFixed(2)}</b>
              <span>{({
                PENDING: "Buscando motorizado",
                CONFIRMED: "Confirmado",
                ASSIGNED: "Motorizado asignado",
                PICKED_UP: order.service_type === "TAXI" ? "Viaje iniciado" : "Paquete recogido",
                DELIVERED: order.service_type === "TAXI" ? "Viaje finalizado" : "Entregado",
                CANCELLED: "Cancelado",
              })[order.status] || order.status}</span>
              <time>{order.created_at}</time>
            </Link>
          ))}
        </section>
      </div>
      <BottomNav />
    </main>
  );
}
